import api from "./api";

export interface Comentario {
  id: string;
  texto: string;
  visivelParaCliente: boolean;
  criadoEm: string;
  autor: { id: string; nome: string; perfil: string };
}

// Time interno
export async function listarComentarios(projetoId: string) {
  const r = await api.get(`/projetos/${projetoId}/comentarios`);
  return r.data.data as Comentario[];
}
export async function criarComentario(projetoId: string, texto: string, visivelParaCliente: boolean) {
  const r = await api.post(`/projetos/${projetoId}/comentarios`, { texto, visivelParaCliente });
  return r.data.data as Comentario;
}
export async function deletarComentario(projetoId: string, id: string) {
  await api.delete(`/projetos/${projetoId}/comentarios/${id}`);
}

// Cliente
export async function clientePostarComentario(projetoId: string, texto: string) {
  const r = await api.post(`/cliente/projetos/${projetoId}/comentarios`, { texto });
  return r.data.data as Comentario;
}

// Briefing/demanda do cliente → vira tarefa na coluna "Demandas" do quadro.
export async function clienteCriarDemanda(
  projetoId: string,
  dados: { titulo: string; descricao?: string; prazoDesejado?: string },
) {
  const r = await api.post(`/cliente/projetos/${projetoId}/demandas`, dados);
  return r.data.data as { id: string; titulo: string };
}
